import { Accordion } from 'flowbite-react';
const AiMlFAQ: React.FC = () => {
    return (
        <>
            <Accordion>
                <Accordion.Panel>
                    <Accordion.Title as="h3" className="accordion-title">
                        Which industries do you serve with your Artificial Intelligence solutions?
                    </Accordion.Title>
                    <Accordion.Content className="accordion-border">
                        <div className="fs-md mb-0 text-secondary dark:text-[#D7DEE5]">
                            We&apos;ve had the opportunity to build AI and machine learning solutions for a wide range of
                            industries - from healthcare and finance to retail, logistics, manufacturing, and even media. But
                            honestly, our focus goes beyond industry labels. We try to understand your business the way you do -
                            your goals, your team&apos;s strengths, and how you work every day. That&apos;s how we build tools
                            that actually make sense to your people and processes.
                        </div>
                    </Accordion.Content>
                </Accordion.Panel>
                <Accordion.Panel>
                    <Accordion.Title as="h3" className="accordion-title">
                        How do you ensure your AI models are fair and transparent?
                    </Accordion.Title>
                    <Accordion.Content className="accordion-border">
                        <div className="fs-md mb-0 text-secondary dark:text-[#D7DEE5]">
                            Fairness in AI isn&apos;t just a technical checkbox - it&apos;s a mindset we carry through every
                            phase. We use methods like SHAP and LIME, which break down how decisions are made, and we integrate
                            interpretability right into our model layers. It&apos;s not just about making smart models. It&apos;s
                            about making ones you can trust, audit, and explain - especially when it matters most.
                        </div>
                    </Accordion.Content>
                </Accordion.Panel>
                <Accordion.Panel>
                    <Accordion.Title as="h3" className="accordion-title">
                        Can your AI solutions run on edge devices?
                    </Accordion.Title>
                    <Accordion.Content className="accordion-border">
                        <div className="fs-md mb-0 text-secondary dark:text-[#D7DEE5]">
                            Yes, they can. They&apos;re designed to thrive in low-connectivity settings too. We&apos;ve deployed
                            models on IoT hubs, wearables, and embedded systems where real-time insights are needed but cloud
                            access isn&apos;t always reliable. What you get is fast processing, stronger privacy, and zero
                            compromise on performance - all right at the edge.
                        </div>
                    </Accordion.Content>
                </Accordion.Panel>
                <Accordion.Panel>
                    <Accordion.Title as="h3" className="accordion-title">
                        What if we don&apos;t have a technical team? Will your solutions still work for us?
                    </Accordion.Title>
                    <Accordion.Content className="accordion-border">
                        <div className="fs-md mb-0 text-secondary dark:text-[#D7DEE5]">
                            Absolutely! That&apos;s something we consciously design for. Not everyone speaks in code, and that
                            shouldn&apos;t be a barrier to using smart technology. Our visual tools and low-code platforms are
                            built for business users, analysts, and anyone who wants to use AI without needing to be a developer.
                            It&apos;s all about giving your team confidence and control.
                        </div>
                    </Accordion.Content>
                </Accordion.Panel>
                <Accordion.Panel>
                    <Accordion.Title as="h3" className="accordion-title">
                        How do you handle data security in your AI solutions?
                    </Accordion.Title>
                    <Accordion.Content className="accordion-border">
                        <div className="fs-md mb-0 text-secondary dark:text-[#D7DEE5]">
                            We take data security way too seriously. Not just because we have to, but because we genuinely
                            understand what&apos;s at stake. Whether we&apos;re working with sensitive medical records or
                            financial data, everything is built around encryption, strict access controls, and full compliance
                            with standards like HIPAA and GDPR. Your trust is never taken lightly.
                        </div>
                    </Accordion.Content>
                </Accordion.Panel>
                <Accordion.Panel>
                    <Accordion.Title as="h3" className="accordion-title">
                        What exactly is Agentic AI, and why is everyone talking about it?
                    </Accordion.Title>
                    <Accordion.Content className="accordion-border">
                        <div className="fs-md mb-0 text-secondary dark:text-[#D7DEE5]">
                            Agentic AI is like giving your software a sense of direction, and the ability to act on it. These
                            systems don&apos;t just wait for instructions. They observe, plan, and make decisions on their own.
                            They can adapt to new information and even choose the best way to complete a task. If you&apos;re
                            looking to automate work at a deeper level, Agentic AI can be a real game-changer.
                        </div>
                    </Accordion.Content>
                </Accordion.Panel>
                <Accordion.Panel>
                    <Accordion.Title as="h3" className="accordion-title">
                        How does Retrieval-Augmented Generation (RAG) improve output quality?
                    </Accordion.Title>
                    <Accordion.Content className="accordion-border">
                        <div className="fs-md mb-0 text-secondary dark:text-[#D7DEE5]">
                            RAG is a bit like giving your AI model access to a library before it answers a question. Instead of
                            relying only on what it was trained on months ago, it quickly pulls in updated or relevant context in
                            real time. That means the responses aren&apos;t just more accurate. They are also grounded in
                            what&apos;s actually happening in the world right now.
                        </div>
                    </Accordion.Content>
                </Accordion.Panel>
                <Accordion.Panel>
                    <Accordion.Title as="h3" className="accordion-title">
                        Why do vector databases matter so much in AI applications?
                    </Accordion.Title>
                    <Accordion.Content className="accordion-border">
                        <div className="fs-md mb-0 text-secondary dark:text-[#D7DEE5]">
                            In simple terms, vector databases help AI understand. Meaning instead of just matching keywords. They
                            make things like chatbot memory, semantic search, and personalized recommendations smarter and more
                            intuitive. Think of them as the memory bank that helps your AI make better decisions based on intent,
                            not just input.
                        </div>
                    </Accordion.Content>
                </Accordion.Panel>
                <Accordion.Panel>
                    <Accordion.Title as="h3" className="accordion-title">
                        Can your AI-powered cybersecurity solutions adapt as threats evolve?
                    </Accordion.Title>
                    <Accordion.Content className="accordion-border">
                        <div className="fs-md mb-0 text-secondary dark:text-[#D7DEE5]">
                            Yes, and that&apos;s exactly what makes them powerful. Unlike older security systems that need
                            constant rule updates, our AI learns from every new threat it encounters. It can flag unusual
                            behavior, stop fraud in its tracks, and detect even those elusive zero-day attacks that traditional
                            systems usually miss. It&apos;s always watching, always learning.
                        </div>
                    </Accordion.Content>
                </Accordion.Panel>
                <Accordion.Panel>
                    <Accordion.Title as="h3" className="accordion-title">
                        How do multi-agent systems (MAS) actually improve operational efficiency?
                    </Accordion.Title>
                    <Accordion.Content className="accordion-border">
                        <div className="fs-md mb-0 text-secondary dark:text-[#D7DEE5]">
                            Imagine several AI agents, each with their own role, working together like a team. That&apos;s what
                            multi-agent systems do. They divide complex operations into smaller tasks, make decisions in parallel,
                            and reduce wait times. It&apos;s not just automation - it&apos;s a smarter, faster way to run things
                            when your operations need to move in real time.
                        </div>
                    </Accordion.Content>
                </Accordion.Panel>
            </Accordion>
        </>
    );
};

export default AiMlFAQ;
